import React, { useEffect, useState, useCallback, useMemo } from 'react';
import Swal from 'sweetalert2';
import '../../../index.scss';
import { customBaseUrl, httpGet, httpPost, httpPut } from '../../../store/http';
import { hideLoader, showLoader } from '../../../utils/loader';
import { Modal, Button, Row } from 'antd';
import CreateNewCount from './updateDays';
import NewBonusAmount from './newBonusAmount';
import { Grid, List, ListItem, IconButton } from "@mui/material";
import ColoredSwitcher from '../../../components/customSwitch/coloredSwitcher';
import { Add } from '@mui/icons-material';

const ReferralSettings = ({ showModal, hideModal, className }) => {
  const [counts, setCounts] = useState([]);
  const [amounts, setAmounts] = useState([]);
  const [showCreateNew, setShowCreateNew] = useState(false);
  const [showCreateNewAmount, setShowCreateNewAmount] = useState(false);
  const [amount, setAmount] = useState('');
  const [description, setDescription] = useState('');
  const [newDayCount, setNewDayCount] = useState('');

  const handleGetReferalCount = useCallback(async () => {
    const response = await httpGet(`${customBaseUrl.referralUrl}/api/v1/admin/config/transaction-count/list`);
    if (response?.status === true) {
      setCounts(response?.data || []);
    }
  }, []);

  const handleGetReferalAmount = useCallback(async () => {
    const response = await httpGet(`${customBaseUrl.referralUrl}/api/v1/admin/config/amount`);
    if (response?.status === true) {
      setAmounts(response?.data || []);
    }
  }, []);

  useEffect(() => {
    handleGetReferalCount();
    handleGetReferalAmount();
  }, [handleGetReferalCount, handleGetReferalAmount]);

  const handleToggleCount = useCallback(async (vendorIndex, countstate, vendor) => {
    showLoader();
    const response = await httpPut(`${customBaseUrl.referralUrl}/api/v1/admin/config/transaction-count/${vendor.id}/toggle`);
    hideLoader();
    if (response.status === true) {
      Swal.fire('Success', response.message, 'success');
      handleGetReferalCount();
    }
  }, [handleGetReferalCount]);

  const handleToggleAmount = useCallback(async (vendorIndex, countstate, amountItem) => {
    showLoader();
    const response = await httpPut(`${customBaseUrl.referralUrl}/api/v1/admin/config/amount/${amountItem.id}/toggle`);
    hideLoader();
    if (response.status === true) {
      Swal.fire('Success', response.message, 'success');
      handleGetReferalAmount();
    }
  }, [handleGetReferalAmount]);

  const handleCreateNewCount = async () => {
    showLoader();
    let res = await httpPost(`${customBaseUrl.referralUrl}/api/v1/admin/config/transaction-count`, {
      numberOfTransaction: newDayCount
    });

    hideLoader();
    if (res.status) {
      setShowCreateNew(false);
      handleGetReferalCount();
      setNewDayCount('');
      Swal.fire('Success', res.message, 'success');
    } else {
      Swal.fire('Failed', res.message, 'error');
    }
  };

  const handleCreateNewAmountAction = async () => {
    showLoader();
    let res = await httpPost(`${customBaseUrl.referralUrl}/api/v1/admin/config/amount`, {
      amount: amount,
      description: description,
      id: 1,
      userType: "ROLE_USER"
    });

    hideLoader();
    if (res.status) {
      setShowCreateNewAmount(false);
      handleGetReferalAmount();
      setAmount('');
      setDescription('');
      Swal.fire('Success', res.message, 'success');
    } else {
      Swal.fire('Failed', res.message, 'error');
    }
  };

  return (
    <Modal
      className={className}
      centered
      visible={showModal}
      onCancel={() => hideModal(false)}
      width={600}
      footer={null}
      title="Referral Settings"
    >
      <div className="row mb-4">
        <div className='col-md-6 mb-2'>
          <Button type="primary" block onClick={() => setShowCreateNew(true)} icon={<Add />}>
            New Bonus Count
          </Button>
        </div>
        <div className='col-md-6 mb-2'>
          <Button type="primary" block onClick={() => setShowCreateNewAmount(true)} icon={<Add />}>
            New Bonus Amount
          </Button>
        </div>
      </div>

      <Grid container spacing={4}>
        <Grid item xs={12} md={6}>
          <h6>Transaction Counts</h6>
          <List dense>
            {counts.map((item) => (
              <ListItem
                key={item.id}
                secondaryAction={
                  <IconButton edge="end">
                    <ColoredSwitcher
                      data={item}
                      id={item.id.toString()}
                      label={''}
                      keyValue={item.id}
                      color="#ff6700"
                      onChange={handleToggleCount}
                    />
                  </IconButton>
                }
              >
                <div style={{ fontWeight: "700" }}>{item.numberOfTransaction} Trans.</div>
              </ListItem>
            ))}
          </List>
        </Grid>
        <Grid item xs={12} md={6}>
          <h6>Bonus Amounts</h6>
          <List dense>
            {amounts.map((item) => (
              <ListItem
                key={item.id}
                secondaryAction={
                  <IconButton edge="end">
                    <ColoredSwitcher
                      data={item}
                      id={item.id.toString()}
                      label={''}
                      keyValue={item.id}
                      color="#ff6700"
                      onChange={handleToggleAmount}
                    />
                  </IconButton>
                }
              >
                <div style={{ fontWeight: "700" }}>{item.amount} NGN</div>
              </ListItem>
            ))}
          </List>
        </Grid>
      </Grid>

      {showCreateNew &&
        <CreateNewCount
          showModal={showCreateNew}
          hideModal={setShowCreateNew}
          newDayCount={newDayCount}
          setNewDayCount={setNewDayCount}
          handleCreateNew={handleCreateNewCount}
        />
      }
      {showCreateNewAmount &&
        <NewBonusAmount
          showModal={showCreateNewAmount}
          hideModal={setShowCreateNewAmount}
          amount={amount}
          setAmount={setAmount}
          description={description}
          setDescription={setDescription}
          handleCreateNew={handleCreateNewAmountAction}
        />
      }
    </Modal>
  );
};

export default ReferralSettings;
